export default {
	datetimePickerAccept: 'Accept',
	datetimePickerCancel: 'Cancel',
	datetimePickerClean: 'Clean'
};
